import * as React from "react";
import { Box, Typography } from "@mui/material";
import { config, styles } from "../../style";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { ReactComponent as BedIcon } from "../../assets/svgs/bed.svg";
import { ReactComponent as BathIcon } from "../../assets/svgs/bath.svg";
import { ReactComponent as SquareIcon } from "../../assets/svgs/square.svg";

const PropertyDetailsCard = ({ item }) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const numberFormatter = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 0,
    });
    return (
        <>
            {item?.applicationListingId && (
                <>
                    <Typography
                        sx={{ color: "#164C63", fontSize: "16px", fontWeight: "600" }}
                        gutterBottom
                        variant="h5"
                        component="div"
                    >
                        {formatter.format(item?.listRent)}/mo
                    </Typography>
                    <Grid sx={{ mt: "-7px" }} container spacing={3} justifyContent={"flex-start"}>
                        <Grid item>
                            <Typography
                                variant="body2"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <BedIcon></BedIcon>
                                <span style={{ marginLeft: "7px" }}>{item?.bedrooms} Beds</span>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="body2"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <BathIcon></BathIcon>
                                <span style={{ marginLeft: "7px" }}>{item.baths} Baths</span>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="body2"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <SquareIcon></SquareIcon>
                                <span style={{ marginLeft: "7px" }}>{numberFormatter.format(item.squareFeet)} ft</span>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Typography sx={{ mt: ".5rem" }} variant="body2">
                        {item.propertyAddress}
                    </Typography>
                </>
            )}

            {!item?.applicationListingId && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        height: "100%",
                        verticalAlign: "middle",
                        alignItems: "center",
                        fontSize: "22px",
                        marginTop: "21px",
                        color: "gainsboro",
                        fontWeight: "700",
                    }}
                >
                    No Proprety
                </Box>
            )}
        </>
    );
};

export { PropertyDetailsCard };
